import React from "react";
import Navbar from "../Components/Common/Navbar";
import studiesData from "../Data/studies.json";

const ExportDataPage = () => {
  return (
    <div className="min-h-screen bg-[#f9f9f9]">
      <Navbar />
      <div className="px-6 md:px-10 py-8">
        <h1 className="text-4xl font-bold text-[#181010] mb-2">View Data</h1>
        <p className="text-gray-600 mb-8 max-w-3xl">
          Access official sources and citations for each dataset.
        </p>
        {studiesData.length > 0 ? (
          studiesData.map((category) => (
            <div key={category.key || category.category} className="mb-8">
              <h2 className="text-2xl font-bold text-[#181010] mb-4">{category.category}</h2>
              <div className="flex flex-col gap-4">
                {category.files.map((file) => (
                  <StudyCard key={file.name} file={file} />
                ))}
              </div>
            </div>
          ))
        ) : (
          <p>Loading studies...</p>
        )}
      </div>
    </div>
  );
};

const StudyCard = ({ file }) => {
  return (
    <div className="border border-gray-200 rounded-xl bg-white shadow-sm p-6">
      <h3 className="text-lg md:text-xl font-semibold text-[#181010]">{file.name}</h3>
      <div className="mt-4">
        {file.link ? (
          <a
            href={file.link}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-4 py-2 bg-[#ff0000] text-white rounded-lg font-bold hover:bg-[#cc0000] transition-colors"
          >
            View Data Source
          </a>
        ) : (
          <span
            className="inline-flex items-center justify-center px-4 py-2 bg-gray-200 text-gray-500 rounded-lg font-bold"
            aria-disabled="true"
          >
            Data source unavailable
          </span>
        )}
      </div>
      <div className="mt-4">
        <p className="text-xs uppercase tracking-wide text-gray-500 font-semibold mb-1">Citation</p>
        <p className="text-sm text-gray-700 leading-relaxed">
          {file.citation || "Citation unavailable for this study."}
        </p>
      </div>
    </div>
  );
};

export default ExportDataPage;
